export const MY_ACCOUNT_TABS = {
  REDEEM_REWARDS: "Redeem Rewards",
  EARN_POINTS: "Earn Points",
  VIEW_GAMES: "View Games",
  DEFAULT_TAB: "View Games"
};

const myAccountTabsData = [
  { id: 1, tabName: MY_ACCOUNT_TABS.EARN_POINTS }, 
  { id: 2, tabName: MY_ACCOUNT_TABS.REDEEM_REWARDS },
  { id: 3, tabName: MY_ACCOUNT_TABS.VIEW_GAMES },
];

export default myAccountTabsData;
